<template>
  <div class="seomain">
    <ul class="tab-tilte four">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main">
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>支付方式：{{ v.paytype }}</p>
              <p>付款状态：{{ v.paystatus }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-xs">
              <router-link :to="'/sale/info/' + v.id" class="st-opt-btn">查看订单详情</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main">
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>付款状态：{{ v.paystatus }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>发货时间：{{ v.shiptime }}</p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-xs">
              <router-link :to="'/sale/info/' + v.id" class="st-opt-btn">查看订单详情</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main">
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>支付方式：{{ v.paytype }}</p>
              <p>付款状态：{{ v.paystatus }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>发货时间：{{ v.shiptime }}</p>
              <p>签收时间：{{ v.receipttime }}</p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/sale/info/' + v.id" class="st-opt-btn">查看订单详情</router-link>
              </div>
              <!-- <div class="st-diyr-btn">
                <p class="st-opt-btn" @click="show_detail_box(v.id)">
                  确认收款
                </p>
              </div> -->
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 3" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist3" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main">
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>支付方式：{{ v.paytype }}</p>
              <p>付款状态：{{ v.paystatus }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>发货时间：{{ v.shiptime }}</p>
              <p>签收时间：{{ v.receipttime }}</p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-xs">
              <router-link :to="'/sale/info/' + v.id" class="st-opt-btn">查看订单详情</router-link>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
      <div class="mix-detail-box">
        <h2>确认收款</h2>
        <p>订单号：{{ oneinfo.ordercode }}</p>
      </div>
    </van-dialog>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待发货", "待签收", "待付款", "已收款"],
      cur: 0,
      show: !1,
      oneinfo: {},
      stlist0: [],
      stlist1: [],
      stlist2: [],
      stlist3: [],
      exShow: false,
      exDataList: [], // 物流信息
      exDialogTitle: "",
      order_code: "", // 关键字搜索
    };
  },
  watch: {},
  computed: {},
  methods: {
    show_detail_box: function(e) {
      this.$post(this.$api.stGetXiaoshouView, { id: e }).then((res) => {
        this.oneinfo = res.data.info;
        this.activeid = res.data.info.id;
        console.log(this.activeid);
        this.show = !0;
      });
    },
    edit_st2: function() {
      let t = this;
      this.$post(this.$api.stGetXiaoshouEdit, { id: this.activeid }).then((res) => {
        if (res.code == 200) {
          this.$toast.success("修改成功");
          this.get_st_list(t.cur);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.stlist3 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("sale_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("sale_activeIndex", value);
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetXiaoshouList, {
        order_code: this.order_code,
        status: this.cur,
        type: this.$route.params.type,
        page: this.page,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let { logisticser, courier } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = logisticser + ": " + courier;
      let result = await this.$post(this.$api.stGetXiaoshouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
  },
  created() {
    this.init();

    let type = this.$route.params.type;
    if (type == 0) {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的销售单" });
      });
    } else if (type == 1) {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的租赁单" });
      });
    } else if (type == 2) {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的海外单" });
      });
    } else if (type == 3) {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的寄售单" });
      });
    } else if (type == 4) {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的投资单" });
      });
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  margin-bottom: 16px;
  width: 100%;
  top: 50px;
}
.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
}
.tab-tilte.four .text-center {
  flex: 1;
}
</style>
